//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'Poster',
  computed: {
    ...mapGetters([
      'tradeConfig',
      'vcId'
    ])
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/components/Poster/Poster.vue